import 'rxjs/add/operator/map';
import { Component, OnInit } from '@angular/core';
import { PushNotificationsService } from 'ng-push';
export interface ViewMemoriesItem {
  name: string;
  id: number;
}
@Component({
  selector: "my-app",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent implements OnInit {

  constructor() {
  } 

  ngOnInit() {
    document.documentElement.style.setProperty('--p-header', '#673ab7');
    document.documentElement.style.setProperty('--p-header-txt', '#ffffff');
    document.documentElement.style.setProperty('--p-background', '#28262a');
    document.documentElement.style.setProperty('--p-txt-color', '#ffffff');
    document.documentElement.style.setProperty('--p-chat-txt-bg', '#673ab7');
    document.documentElement.style.setProperty('--p-chat-rx-txt-bg', '#6c757d');
    document.documentElement.style.setProperty('--p-input-txt-clr', '#c5c4c4');
  }

}
